import { GET_PIER_MESSAGE } from "../../actionTypes/actionsTypes";
import defaultAsyncReducer from "../../defaultReducer";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface pierMessageState extends BaseAsyncReducerState {
    enabled: number;
    tut_enabled: number;
    message_en?: string;
    message_fr?: string;
}

const initialState: pierMessageState = {
    enabled: 0,
    tut_enabled: 0,
    loading: false,
    error: false
}
  

function pierMessageReducer(state = initialState, action: AppAction): pierMessageState | BaseAsyncReducerState | Record<string, unknown> {
    return defaultAsyncReducer(state, action, GET_PIER_MESSAGE);
}



export default pierMessageReducer;